export const DELIVERYMAN_NOT_FOUND_TOAST = {
  message: 'Entregador não encontrado',
  toastId: 'deliveryman-not-found',
};

export enum GENDER_TYPES {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export const GENDER_TEXT: Record<GENDER_TYPES, string> = {
  MALE: 'Masculino',
  FEMALE: 'Feminino',
  OTHER: 'Outro',
};

export enum ENUM_STATUS_PRE_REGISTRATION {
  NEW_REGISTER_PEDING_VALIDATION = 'NEW_REGISTER_PEDING_VALIDATION',
  REPROVED_PEDING_RESEND_DOCUMENTATION = 'REPROVED_PEDING_RESEND_DOCUMENTATION',
  REPROVED_NEW_DOCUMENTATION_PROVIDED = 'REPROVED_NEW_DOCUMENTATION_PROVIDED',
  REPROVED_FOR_CHECK = 'REPROVED_FOR_CHECK',
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
}

export const TRANSLATE_STATUS_PRE_REGISTRATION: Record<
  ENUM_STATUS_PRE_REGISTRATION,
  string
> = {
  [ENUM_STATUS_PRE_REGISTRATION.NEW_REGISTER_PEDING_VALIDATION]:
    'Novo cadastro - pendente de validação',
  [ENUM_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED]:
    'Reprovado - nova documentação aportada',
  [ENUM_STATUS_PRE_REGISTRATION.REPROVED_PEDING_RESEND_DOCUMENTATION]:
    'Reprovado - aguardando documentação',
  [ENUM_STATUS_PRE_REGISTRATION.REPROVED_FOR_CHECK]: 'Reprovado - checagem',
  [ENUM_STATUS_PRE_REGISTRATION.APPROVED]: 'Aprovado',
  [ENUM_STATUS_PRE_REGISTRATION.DELETED]: 'Excluído',
};

export enum ENUM_ACCOUNT_TYPE {
  SAVINGS_ACCOUNT = 'SAVINGS_ACCOUNT',
  CURRENT_ACCOUNT = 'CURRENT_ACCOUNT',
}

export const TRANSLATE_ACCOUNT_TYPE: Record<ENUM_ACCOUNT_TYPE, string> = {
  [ENUM_ACCOUNT_TYPE.SAVINGS_ACCOUNT]: 'Poupança',
  [ENUM_ACCOUNT_TYPE.CURRENT_ACCOUNT]: 'Corrente',
};

export enum ENUM_PERSON_ACCOUNT_TYPE {
  FISIC = 'FISICA',
  JURIDIC = 'JURIDICA',
}
